import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { Seperator } from './Seperator';
import './css/AccountInfoModal.css';

export function AccountInfoModal({ user, shown, closeModal, updateUser, groups }) {

    useEffect(() => {
        if (shown) {
            $('#more-modal-container').fadeIn(300);
            $('#more-modal-container').css('display', 'flex');
            $('#more-modal').css({ "margin-left": "2000px" }).animate({ "margin-left": "0px" }, 300)
            fetchRole();
        }
    }, [shown])

    function fetchRole() {
        fetch(`/api/accounts/${user.uuid}/role`)
            .then(response => response.json())
            .then(result => {
                groups.forEach((group) => {
                    if (result.find(tag => tag.group_UUID == group.uuid)) {
                        $(`#${group.uuid}`).prop('checked', true);
                    }
                    else {
                        $(`#${group.uuid}`).prop('checked', false);
                    }
                })
            })
            .catch(error => console.log('error', error));
    }

    function handleSave() {
        let tag = {};
        groups.forEach(group => {
            tag[group.uuid] = $(`#${group.uuid}`).is(':checked');
        });

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: JSON.stringify(tag),
            redirect: 'follow'
        };

        fetch(`/api/accounts/${user.uuid}/role`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
            })
            .catch(error => console.log('error', error));
    }

    return (
        <>
            <div className="account-info-container" id="more-modal-container"
                onClick={(event) => {
                    var $target = $(event.target);
                    if (!$target.closest('#more-modal').length &&
                        $('#more-modal-container').is(":visible") &&
                        !$('#previewer-container').is(":visible")) {
                        closeModal();
                        $('#more-modal-container').fadeOut(300);
                        $('#more-modal').css("margin-left", "0px")
                            .animate({ "margin-left": "2000px" }, 300);
                    }
                }}>
                <div className="account-info" id="more-modal" onClick={(e) => { e.stopPropagation() }}>
                    <div className="bar">
                        <div className="info-title">
                            User Name:
                        </div>
                        <div className="text-18pt" style={{ color: "#094EFF" }}>
                            {user?.username}
                        </div>
                    </div>
                    <Seperator width={726} />
                    <div className="bar">
                        <div className="info-title">
                            Last login:
                        </div>
                        <div className="text-18pt" style={{ color: "#094EFF" }}>
                            {user?.lastLogin}
                        </div>
                    </div>
                    <div className="bar">
                        <div className="info-title">
                            Note:
                        </div>
                        <div className="text-18pt" style={{ color: "#094EFF" }}>
                            <input
                                defaultValue={user?.note}
                                onBlur={(e) => { updateUser(user.uuid, "note", e.target.value) }}
                                placeholder='Note something...'
                            />
                        </div>
                    </div>
                    <div className="bar">
                        <div className="info-title">
                            Function Group:
                        </div>
                        <div className="text-18pt" style={{ color: "#094EFF", alignSelf: 'flex-start' }}>
                            {groups.map((group) => {
                                return (
                                    <div className="form-check" key={group.uuid}>
                                        <input className="form-check-input" type="checkbox" id={group.uuid} />
                                        <label className="form-check-label" htmlFor={group.uuid}>
                                            {group.name}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <button onClick={() => { handleSave() }}>Save</button>
                </div>
            </div>
        </>
    );
}
